module.exports = __webpack_public_path__ + "Server-Healthy.AzureCloudService.f244dff0476e14ce1df339ce61945790.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Healthy.AzureCloudService.png
// module id = 1605488152743165
// module chunks = 1